import React from 'react'
import { map } from 'lodash'
import styled from 'styled-components';
import { Box, Flex } from 'rebass'
import { Dimmer, Loader } from "semantic-ui-react";

import { __ } from '~/i18n'
import { formatMoney, calculateCartTotal } from '~/utils/money'
import { getShowShipping, getShowDiscount, getShowServiceFee, getShowTaxNotice } from "~/logic";

const CartTotalContainer = styled.div`
  padding-top: 12px;
  margin-bottom: 12px;
  position: relative;
`;

const TotalLabel = styled.span`
  font-size: 16px;
  color: #1B2125;
  line-height: 24px;
`;

const TotalValue = styled.span`
  font-size: 16px;
  color: #1B2125;
  text-align: right;
  line-height: 24px;
  font-weight: bold;
`;

const VatText = styled.span`
  color: #868686;
  padding: 4px 0;
`;

const DiscountValue = styled(TotalValue)`
  color: ${props => props.theme.discount}
`;

const AlignBox = styled(({ textAlign, ...rest }) => <Box {...rest} />)`
  text-align: ${props => (props.textAlign)}
`;

export default class CartTotal extends React.PureComponent {
  getDiscountLabel = () => {
    const { cart } = this.props;
    return `${__("Discount")} (${map(cart.discounts, (discount) => (discount.label.replace('.00', ''))).join(', ')})`
  };
  render() {
    const { cart, shop, loading } = this.props;

    const showShipping = getShowShipping(cart);
    const showTaxNotice = getShowTaxNotice(shop);
    const showServiceFee = getShowServiceFee(cart);
    const showDiscount = getShowDiscount(cart);

    const total = formatMoney(calculateCartTotal(cart));

    return (
      <CartTotalContainer flexWrap='wrap' alignItems={ 'center' }>
        <Dimmer active={ loading } inverted>
          <Loader inverted />
        </Dimmer>
        { showServiceFee ?
          <Flex alignItems={ 'center' } mx={ -4 }>
            <Box px={ 4 } py={ 1 } width={ 0.5 }>
              <TotalLabel>{ __("Service Fee") }</TotalLabel>
            </Box>
            <AlignBox px={ 4 } py={ 1 } width={ 0.5 } textAlign="right">
              <TotalValue>{ formatMoney(cart.service_fee) }</TotalValue>
            </AlignBox>
          </Flex>
        : null }
        { showDiscount ?
          <Flex alignItems={ 'center' } mx={ -4 }>
            <Box px={ 4 } py={ 1 } width={ 0.5 }>
              <TotalLabel>{ this.getDiscountLabel() }</TotalLabel>
            </Box>
            <AlignBox px={ 4 } py={ 1 } width={ 0.5 } textAlign="right">
              <DiscountValue>{ `-${formatMoney(cart.discount_amount)}` }</DiscountValue>
            </AlignBox>
          </Flex>
        : null }
        { showShipping ?
          <Flex alignItems={ 'center' } mx={ -4 }>
            <Box px={ 4 } py={ 1 } width={ 0.5 }>
              <TotalLabel>{ __("Shipping") }</TotalLabel>
            </Box>
            <AlignBox px={ 4 } py={ 1 } width={ 0.5 } textAlign="right">
              <TotalValue>{ formatMoney(cart.shipping_price) }</TotalValue>
            </AlignBox>
          </Flex>
        : null }
        <Flex alignItems={ 'center' } mx={ -4 }>
          <Box px={ 4 } py={ 1 } width={ 0.5 }>
            <TotalLabel>{ __("Total") }</TotalLabel>
          </Box>
          <AlignBox px={ 4 } py={ 1 } width={ 0.5 } textAlign="right">
            <TotalValue>{ total }</TotalValue>
          </AlignBox>
        </Flex>
        { showTaxNotice ?
          <VatText>{ __("Prices include VAT") }</VatText>
        : null }
      </CartTotalContainer>
    )
  }
}
